import { v4 } from 'uuid'

import { store } from '@/store/store'
import { ADD_TOAST, SET_SHOW } from '@/store/toasts/actions/types'

const createToast = (message: string) => {
  const key = v4()
  const toast = {
    key,
    show: true,
    text: message,
  }
  store.dispatch({ payload: toast, type: ADD_TOAST })
}

const hideToast = (key: string) => {
  store.dispatch({ payload: { key, show: false }, type: SET_SHOW })
}

const toastService = {
  createToast,
  hideToast,
}

export default toastService
